// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminAddCallInfoForm_wrapper__1b1Qx","buttons":"AdminAddCallInfoForm_buttons__GNVZw"};